<template><section><template>
<h3>Alert</h3>
<div class="bs-docs-section" id="Alert">
<div class="bs-example">
<blockquote>
<p>component</p>
</blockquote>
<p><n3-button type="success" @click.native="openRight">
open right
</n3-button>
<n3-button type="danger" @click.native="openTop">
open top
</n3-button></p>
  <hr>
  <n3-alert dismissable="" :show="true" icon="smile-o">
    <strong>default style</strong>
    This is the default style.
  </n3-alert>
  <br>
  <n3-alert type="success" :show="true">
    <strong>Well Done!</strong>
    You successfully read this important alert message.
  </n3-alert>
  <br>
  <n3-alert type="info" :show="true">
    <strong>Heads up!</strong> This alert needs your attention, but it's not super important.
  </n3-alert>
  <br>
  <n3-alert type="danger" dismissable="" :show="true">
    <strong>Oh snap!</strong> Change a few things up and try submitting again.
  </n3-alert>
  <br>
  <n3-alert type="warning" dismissable="" :show="true">
    <strong>Warning!</strong> Better check yourself, you're not looking too good.
    <hr>
  </n3-alert>
  <br>
  <n3-alert :show="true" type="success" width="700px" message="Tip" description="">
    Tip content
  </n3-alert>
  <br>
  <n3-alert :show="true" type="danger" width="700px" message="Error" description="" dismissable="">
    Error content
  </n3-alert>
  <br>
  <n3-alert :show="true" type="info" width="700px" message="Error" :on-close="close" description="" dismissable="">
    click close button
  </n3-alert>
  <n3-alert ref="alertRight" type="success" width="700px" placement="top-right" message="Tip" description="" dismissable="">
    <p>You successfully read this important alert message.</p>
  </n3-alert>
  <n3-alert ref="alertTop" :duration="3000" type="danger" placement="top" message="Warning" description="" dismissable="">
    <strong>Heads up!</strong>
    <p>This alert needs your attention.</p>
  </n3-alert>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">'success'</span>
    <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"openRight"</span>&gt;</span>
    open right
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">'danger'</span>
    <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"openTop"</span>&gt;</span>
    open top
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">hr</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span> <span class="hljs-attr">dismissable</span> <span class="hljs-attr">:show</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"smile-o"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">strong</span>&gt;</span>default style<span class="hljs-tag">&lt;/<span class="hljs-name">strong</span>&gt;</span>
    This is the default style.
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span> <span class="hljs-attr">:show</span>=<span class="hljs-string">"true"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">strong</span>&gt;</span>Well Done!<span class="hljs-tag">&lt;/<span class="hljs-name">strong</span>&gt;</span>
    You successfully read this important alert message.
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"info"</span> <span class="hljs-attr">:show</span>=<span class="hljs-string">"true"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">strong</span>&gt;</span>Heads up!<span class="hljs-tag">&lt;/<span class="hljs-name">strong</span>&gt;</span> This alert needs your attention, but it's not super important.
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span> <span class="hljs-attr">dismissable</span> <span class="hljs-attr">:show</span>=<span class="hljs-string">"true"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">strong</span>&gt;</span>Oh snap!<span class="hljs-tag">&lt;/<span class="hljs-name">strong</span>&gt;</span> Change a few things up and try submitting again.
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warning"</span> <span class="hljs-attr">dismissable</span> <span class="hljs-attr">:show</span>=<span class="hljs-string">"true"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">strong</span>&gt;</span>Warning!<span class="hljs-tag">&lt;/<span class="hljs-name">strong</span>&gt;</span> Better check yourself, you're not looking too good.
    <span class="hljs-tag">&lt;<span class="hljs-name">hr</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span>
    <span class="hljs-attr">:show</span>=<span class="hljs-string">"true"</span>
    <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span>
    <span class="hljs-attr">width</span>=<span class="hljs-string">"700px"</span>
    <span class="hljs-attr">message</span>=<span class="hljs-string">"Tip"</span>
    <span class="hljs-attr">description</span>&gt;</span>
    Tip content
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span>
    <span class="hljs-attr">:show</span>=<span class="hljs-string">"true"</span>
    <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>
    <span class="hljs-attr">width</span>=<span class="hljs-string">"700px"</span>
    <span class="hljs-attr">message</span>=<span class="hljs-string">"Error"</span>
    <span class="hljs-attr">description</span>
    <span class="hljs-attr">dismissable</span>&gt;</span>
    Error content
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span>
    <span class="hljs-attr">:show</span>=<span class="hljs-string">"true"</span>
    <span class="hljs-attr">type</span>=<span class="hljs-string">"info"</span>
    <span class="hljs-attr">width</span>=<span class="hljs-string">"700px"</span>
    <span class="hljs-attr">message</span>=<span class="hljs-string">"Error"</span>
    <span class="hljs-attr">:on-close</span>=<span class="hljs-string">"close"</span>
    <span class="hljs-attr">description</span>
    <span class="hljs-attr">dismissable</span>&gt;</span>
    click close button
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span>
    <span class="hljs-attr">ref</span>=<span class="hljs-string">"alertRight"</span>
    <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span>
    <span class="hljs-attr">width</span>=<span class="hljs-string">"700px"</span>
    <span class="hljs-attr">placement</span>=<span class="hljs-string">"top-right"</span>
    <span class="hljs-attr">message</span>=<span class="hljs-string">"Tip"</span>
    <span class="hljs-attr">description</span>
    <span class="hljs-attr">dismissable</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>You successfully read this important alert message.<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-alert</span>
    <span class="hljs-attr">ref</span>=<span class="hljs-string">"alertTop"</span>
    <span class="hljs-attr">:duration</span>=<span class="hljs-string">"3000"</span>
    <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>
    <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span>
    <span class="hljs-attr">message</span>=<span class="hljs-string">"Warning"</span>
    <span class="hljs-attr">description</span>
    <span class="hljs-attr">dismissable</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">strong</span>&gt;</span>Heads up!<span class="hljs-tag">&lt;/<span class="hljs-name">strong</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>This alert needs your attention.<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-alert</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    openRight () {
      <span class="hljs-keyword">this</span>.$refs.alertRight.open()
    },
    openTop () {
      <span class="hljs-keyword">this</span>.$refs.alertTop.open()
    },
    close () {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'you click the close button'</span>)
    }
  }
}
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>show</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>whether a Alert is visible or not</td>
</tr>
<tr>
<td>icon</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>icon</td>
</tr>
<tr>
<td>dismissable</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>whether a close button is visible or not</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code>, one of <code v-pre="">default</code> <code v-pre="">success</code> <code v-pre="">info</code> <code v-pre="">warning</code> <code v-pre="">danger</code></td>
<td><code v-pre="">success</code></td>
<td>type of Alert</td>
</tr>
<tr>
<td>duration</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">0</code></td>
<td>duration setting ,you can set it as <code v-pre="">0</code> to prevent Alert to be closed</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>small</td>
<td><code v-pre="">Boolean</code></td>
<td></td>
<td>small style</td>
</tr>
<tr>
<td>placement</td>
<td><code v-pre="">String</code>. 如: <code v-pre="">top</code>, <code v-pre="">top-right</code>,<code v-pre="">top-left</code>, <code v-pre="">bottom</code>,<code v-pre="">bottom-left</code>, <code v-pre="">bottom-right</code></td>
<td></td>
<td>placement of Alert</td>
</tr>
<tr>
<td>description</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>whether a description is visible or not</td>
</tr>
<tr>
<td>message</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>work when description is <code v-pre="">true</code></td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>close</td>
<td>emited when  Alert is closed</td>
<td></td>
</tr>
<tr>
<td>show</td>
<td>emited when Alert show</td>
<td></td>
</tr>
<tr>
<td>hide</td>
<td>emited when Alert hide</td>
<td></td>
</tr>
</tbody>
</table>
<blockquote>
<p>Method</p>
</blockquote>
<p><n3-button type="success" @click.native="open">
Method
</n3-button></p>
<pre v-pre=""><code v-pre="" class="language-javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    showAlert () {
      <span class="hljs-keyword">this</span>.n3Alert({
        <span class="hljs-attr">content</span>: <span class="hljs-string">'success'</span>,
          <span class="hljs-attr">type</span>: <span class="hljs-string">'success'</span>,
          <span class="hljs-attr">placement</span>: <span class="hljs-string">'top-right'</span>,
          <span class="hljs-attr">duration</span>: <span class="hljs-number">2000</span>,
          <span class="hljs-attr">width</span>:<span class="hljs-string">'200px'</span> <span class="hljs-comment">// please set the width when the content is unknown </span>
      })
    },
  }
}
</code></pre>
</div>
</template>


</section></template>
<style>
.alert-icon-float-left {
  font-size:32px;float:left;margin-right:5px;
}
</style>
<script>
  import n3Alert from 'src/Alert/n3Alert.vue'
  import n3Button from 'src/Button/n3Button.vue'

  export default {
    methods: {
      openRight () {
        this.$refs.alertRight.open()
      },
      openTop () {
        this.$refs.alertTop.open()
      },
      close () {
        console.log('you click close button')
      },
      open () {
        this.n3Alert({
          content: 'success',
          type: 'success',
          placement: 'top-right',
          duration: 2000,
          width:'200px'
        })
      }
    },
    components: {
      n3Alert,
      n3Button
    }
  }
</script>


// WEBPACK FOOTER //
// n3AlertDocs.md?d3427cf4